import { useMemo } from "react";

const { selectRoles } = require("@/store/slices/roles/rolesSlice");
const { useSelector } = require("react-redux");

const useRoles = (roleName) => {
  const { roles } = useSelector(selectRoles);

  const memoized = useMemo(() => {
    if (!roles || typeof roles !== "object") {
      return false;
    }
    return findKeyAndValue(roles, roleName);
  }, [roleName, roles]);

  return { getPermission: memoized };
};

export default useRoles;

function findKeyAndValue(obj, targetKey) {
  for (let key in obj) {
    if (key === targetKey) {
      return obj[key]; // Key found return value
    }

    if (typeof obj[key] === "object") {
      const found = findKeyAndValue(obj[key], targetKey);
      if (found) {
        return found; // Key found in nested object return it's value
      }
    }
  }

  return false; // Key not found
}
